import { CalendarAltLight } from 'emerald-icons/dist/CalendarAltLight';
import { LabeledValue_Root, Svg } from 'emerald-ui';
import { gray1, gray5 } from 'emerald-ui/dist/globals/colors';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { font } from 'emerald-ui/dist/globals/fonts';

export const DataSubHeaderRow_Root = styled.dl`
    display: flex;
    align-items: center;
    flex-grow: 1;
    flex-shrink: 1;
    background: ${gray1};

    ${LabeledValue_Root} {
        padding: .75em 1em;
        font-size: 1rem;
    }

    ${theme.breakpoints.only('xs')} {
        flex-wrap: wrap;
    }
`;

export const DataSubHeaderRow_CargoIcon = styled(Svg)`
    width: 2em;
    margin: .25em 0 0 1em;
    path {
        fill: ${gray5};
    }
`;

export const DataSubHeaderRow_CalendarIcon = styled(CalendarAltLight)`
    color: ${gray5};
    font-size: 2em;
    margin-left: .5em;
`;

export const DataSubHeaderRow_EmptyState = styled.div`
    font-size: 1.25rem;
    color: ${gray5};
    padding: 1rem;
    font-family: ${font.medium};
    width: 100%;
`;
